import React from 'react';

interface VimeoVideoComponentProps {
  videoID: string;
}

const VimeoVideo: React.FC<VimeoVideoComponentProps> = ({ videoID }) => {
  return (
    <iframe
      width="800"
      height="450"
      className="max-w-full"
      src={`https://player.vimeo.com/video/${videoID}`}
      title="Vimeo video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
}

export default VimeoVideo;